<template>
  <div class="basic-select-wrapper">
    <NativeSelect
      :selectId="pid"
      :value="computedValue"
      :options="options"
      :label="label"
      :style="selectStyle"
      :class="['basic-select', { isErrorTooltip: errorTooltipText }]"
    />
    <div v-if="errorTooltipText && (!isValidInternal)" class="basic-select-icon">
      <TooltipPlugin :tooltipText="errorTooltipText">
        <template #tooltip-btn>
          <img src="@/assets/images/icons/alert-circle.svg" />
        </template>
      </TooltipPlugin>
    </div>
  </div>
</template>

<script>
import { TooltipPlugin, NativeSelect } from '@n11/so-ui-components';

export default {
  name: 'BasicNativeSelect',
  components: { TooltipPlugin, NativeSelect },
  props: {
    pid: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    selectValue: {
      type: [String, Number, null],
      required: false,
      default: "",
    },
    isValid: {
      type: Boolean,
      required: true
    },
    options: {
      type: Object,
      default: {},
      required: false,
    },
    errorTooltipText: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    selectStyle() {
      return {
        width: '100%',
        borderColor: !this.isValid ? '#FF3939' : '',
        outline: !this.isValid ? '3px solid #FFD7D7' : ''
      }
    },
    computedValue: {
      get() {
        return this.selectValue;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    isValid(newValidity) {
      this.isValidInternal = newValidity;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.basic-select-wrapper {
  display: inline-flex;
  padding: 10px 12px;
  flex-direction: column;
  width: 100%;
  position: relative;

  label {
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: $colorN80;
  }
  .disabled-button {
    background-color: grey;
    cursor: not-allowed;
  }

  .basic-select {
    &-icon {
      position: absolute;
      z-index: 1;
      right: 18px;
      top: 21px;
      cursor: pointer;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }

}
</style>
